import React, { ReactNode } from 'react'
import { Paper, PaperProps } from '@mui/material'

interface CustomPaperProps extends PaperProps {
  children: ReactNode
}

const SectionContainer: React.FC<CustomPaperProps> = ({ children, sx, ...props }) => {
  return (
    <Paper
      variant="outlined"
      {...props}
      sx={{
        mb: 6,
        borderRadius: 7,
        borderColor: '#E8E8E8',
        ...sx, // overwrites
      }}>
      {children}
    </Paper>
  )
}

export default SectionContainer
